import { CR_SUBMISSION } from '../constants';

type ShowSuccessViewParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
};
export const showSuccessView = async ({ rootElement }: ShowSuccessViewParams) => {
    const formElement = rootElement.querySelector<HTMLFormElement>(CR_SUBMISSION.PAGE.FORM_SELECTOR);
    const actionsElement = rootElement.querySelector<HTMLElement>(CR_SUBMISSION.PAGE.ACTIONS_SELECTOR);
    const successBannerElement = rootElement.querySelector<HTMLElement>(CR_SUBMISSION.PAGE.SUCCESS_BANNER_SELECTOR);

    formElement?.classList.add(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_HIDDEN_CLASS);
    actionsElement?.classList.add(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_HIDDEN_CLASS);
    successBannerElement?.classList.remove(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_HIDDEN_CLASS);

    if (formElement === null) throw new Error('[CR-Submission] showSuccessView: Form not found');
    if (actionsElement === null) throw new Error('[CR-Submission] showSuccessView: Actions not found');
    if (successBannerElement === null) throw new Error('[CR-Submission] showSuccessView: Success banner not found');

    try {
        const response = await fetch('/reco-core/cinemas/emptybasket');
        const data = await response.text();
        insertAndExecuteScripts(successBannerElement, data);
    } catch {
        /*     */
    }
};

/**
 *
 *
 *
 *
 *
 *
 *
 */
function insertAndExecuteScripts(parentElement: HTMLElement, htmlContent: string) {
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlContent;
    const scriptElements = tempContainer.querySelectorAll('script');

    /*                                           */
    scriptElements.forEach(oldScript => {
        const newScript = document.createElement('script');
        newScript.text = oldScript.textContent || '';
        Array.from(oldScript.attributes).forEach(attr => {
            newScript.setAttribute(attr.name, attr.value);
        });
        oldScript.parentNode?.replaceChild(newScript, oldScript);
    });

    while (tempContainer.firstChild) {
        parentElement.appendChild(tempContainer.firstChild);
    }
}
